import API from "@/package/config/main-api";
import { IFeaturesFlagsResponse } from "@/package/global-types";

export const apiGetFeaturesFlags = () => {
  return API.get<IFeaturesFlagsResponse>("api/v1/client/features");
};
